module.exports = __webpack_public_path__ + "img/bandage.15e521c7.svg";